// ======================================================================
// File Name       : UserHistoryStudentResultDrillResult
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col } from 'react-bootstrap';
import * as ReportConstants from '../../../constants/ScoringReportConstants';

class UserHistoryStudentResultDrillResult extends React.Component {
  openDialog(questionObj) {
    this.props.openDialog(questionObj);
  }

  drawTable(tableData) {
    let length = 0;
    let colLength = ReportConstants.USER_HISTORY_LIST_RESULT_DEFAULT_COLUMN;
    const tableLength = tableData.length;
    if (tableLength < colLength) {
      length = 1;
      colLength = tableLength;
    } else {
      const mod = (tableLength % colLength) ? 1 : 0;
      length = parseInt((tableLength / colLength), 10) + mod;
    }
    
    const body = [];
    for (let i = 0; i < length; i++) {
      body.push(this.drawRow(i, tableData, colLength));
    }
    return body;
  }

  drawRow(rowIndex, tableData, colLength) {
    const labelCols = [];
    const resultCols = [];
    for (let i = 0; i < colLength; i++) {
      const tableIndex = i + (colLength * rowIndex);
      let label = '';
      let result = '';
      if (tableData[tableIndex]) {
        label = tableData[tableIndex].label || '';
        result = tableData[tableIndex].result;
        switch (parseInt(result, 10)) {
          case ReportConstants.ANSWER_JUDGE_RESULT.CORRECT:
            result = '◯';
            break;
          case ReportConstants.ANSWER_JUDGE_RESULT.INCORRECT:
            result = '☓';
            break;
          case ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER:
            result = '△';
            break;
          default:
            break;
        }
      }
      const addLabelCol = (
        <td
          key={tableIndex}
          onClick={label ? this.openDialog.bind(this, tableData[tableIndex]) : null}
          className={label ? 'cursor_pointer text-center user-history-result-table-style' :
                    'border-none background-none'}
        >
          {label}
        </td>
      );
      const addResultCol = (
        <td
          key={tableIndex}
          onClick={result ? this.openDialog.bind(this, tableData[tableIndex]) : null}
          className={result ? 'cursor_pointer text-center user-history-result-table-style' :
                    'border-none background-none'}
        >
          {result}
        </td>
      );
      labelCols.push(addLabelCol);
      resultCols.push(addResultCol);
    }
    return (
      <tbody key={rowIndex} style={{ borderTop: 'none' }}>
        <tr>
          {labelCols}
        </tr>
        <tr>
          {resultCols}
        </tr>
      </tbody>
    );
  }

  render() {
    const { questionResultList } = this.props;
    const body = questionResultList ? this.drawTable(questionResultList) : null;
    return (
      <div id="userHistoryResultTable">
        <Col sm={12}>
          <div className="margin-top-10 margin-bottom-10"><h3>問題の正誤情報</h3></div>
          <Table striped hover className="margin-top-10">
            <thead />
            {body}
          </Table>
        </Col>
      </div>
    );
  }
}

export default UserHistoryStudentResultDrillResult;
